const CHATBOT_TEXT_SEND_LOCK_KEY = '__ilm_chatbot_text_send_lock__'

/** Cross-instance lock: one in-flight text chat request for the whole app (survives duplicate handlers / HMR). */
export function acquireChatbotTextSendLock(): boolean {
  if ((globalThis as any)[CHATBOT_TEXT_SEND_LOCK_KEY]) {
    return false
  }
  ;(globalThis as any)[CHATBOT_TEXT_SEND_LOCK_KEY] = true
  return true
}

export function releaseChatbotTextSendLock(): void {
  ;(globalThis as any)[CHATBOT_TEXT_SEND_LOCK_KEY] = false
}
